"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CurrentUserPermissionsMigration = void 0;
var _mapKeys = _interopRequireDefault(require("lodash/mapKeys"));
var _camelCase = _interopRequireDefault(require("lodash/camelCase"));
var _cloneDeep = _interopRequireDefault(require("lodash/cloneDeep"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const deserialize = responseJSON => {
  // The /users/me endpoint currently returns the "issues.new" object with snake_case keys.
  // This is supposed to be fixed in the future.

  // Clone the JSON object to avoid modifying the original object (read only when cached by react-query).
  const clonedJSON = (0, _cloneDeep.default)(responseJSON);

  // TODO: remove this function when the response is standardized in the backend.
  clonedJSON.issues.new = (0, _mapKeys.default)(clonedJSON.issues.new, (_, key) => (0, _camelCase.default)(key));
  return clonedJSON;
};
const CurrentUserPermissionsMigration = exports.CurrentUserPermissionsMigration = {
  deserialize
};
//# sourceMappingURL=CurrentUserPermissionsMigration.js.map